export const dragReorder = <
  T extends { id: number; weight?: number; name?: string }
>(
  list: T[],
  startIndex: number,
  endIndex: number
) => {
  const [removed] = list.splice(startIndex, 1)
  list.splice(endIndex, 0, removed)
  const res = list.map((r, index) => ({ ...r, groupWeight: index }))

  return res
}

export const dragWeightReorder = <
  T extends { id: number; weight?: number; name?: string }
>(
  list: T[],
  startIndex: number,
  endIndex: number
) => {
  const [removed] = list.splice(startIndex, 1)
  list.splice(endIndex, 0, removed)
  const res = list.map((r, index) => ({ ...r, weight: index }))

  return res
}
